/* eslint-disable no-undef, no-unused-vars */
// added for facet load more issue when section redirection
( ( $ ) => {
  $( document ).on( 'click', 'a[href^="#"]', () => {
    window.is_hash_button_click = true;
  } );
} )( jQuery );

window.addEventListener( 'popstate', ( e ) => {  
  if ( window.is_hash_button_click ) {
    FWP.loaded = true;
    window.is_hash_button_click = false;
  } 
} );

const fwResourcePostBlock = document.querySelector( '.bs-section--resource-posts' );

document.addEventListener( 'facetwp-loaded', function() {
  fwResourcePostBlock?.classList.add( 'bs-section--resource-posts--show' );
} );
